export const categoryOption = [
  { value: 'trial', label: 'Hàng mới' },
  { value: 'cancel', label: 'Huỷ đặt' },
  { value: 'suggest', label: 'Khuyến nghị' },
  { value: 'reorder', label: 'Ngoài danh mục' },
  { value: 'lock', label: 'Khoá đặt' },
];
export const approvalStatus = [
  { value: 0, label: 'Mới tạo' },
  { value: 1, label: 'TVV duyệt gửi CHT' },
  { value: 2, label: 'CHT từ Chối' },
  { value: 3, label: 'CHT duyệt gửi CN' },
  { value: 4, label: 'CN từ Chối' },
  { value: 5, label: 'CN duyệt gửi HS' },
  { value: 6, label: 'HS từ chối' },
  { value: 7, label: 'HS duyệt' },
];
export const approvalOption = [
  { value: 1, label: '1 cấp' },
  { value: 2, label: '2 cấp' },
  { value: 3, label: '3 cấp' },
  { value: 4, label: '4 cấp' },
];
export const approvalDateOption = [
  { value: 1, label: '1 ngày' },
  { value: 2, label: '2 ngày' },
  { value: 3, label: '3 ngày' },
  { value: 4, label: '4 ngày' },
];

export const historyApproval = [
  {
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    timeCreated: '17:00',
    dateCreated: '23/07/2023',
    status: '1',
    reason: '',
  },
  {
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    timeCreated: '17:00',
    dateCreated: '23/07/2023',
    status: 1,
    reason: '',
  },
  {
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    timeCreated: '17:00',
    dateCreated: '23/07/2023',
    status: 0,
    reason: 'Vượt mức vốn tồn phân bố',
  },
];

export const feedbackApproval = [
  {
    id: 1,
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    content: 'Thông tin chưa chính xác, cần chỉnh sủa lại mã MJHAJSHAJSHJA',
    created_at: '17:00 23/11/2023',
    file: 'file.rar',
  },
  {
    id: 2,
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    content: 'Thông tin chưa chính xác, cần chỉnh sủa lại mã MJHAJSHAJSHJA',
    created_at: '17:00 23/11/2023',
  },
  {
    id: 3,
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    content: 'Thông tin chưa chính xác, cần chỉnh sủa lại mã MJHAJSHAJSHJA',
    created_at: '17:00 23/11/2023',
    file: 'file.rar',
  },
  {
    id: 4,
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    content: 'Thông tin chưa chính xác, cần chỉnh sủa lại mã MJHAJSHAJSHJA',
    created_at: '17:00 23/11/2023',
    file: 'file.rar',
  },
  {
    id: 5,
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    content: 'Thông tin chưa chính xác, cần chỉnh sủa lại mã MJHAJSHAJSHJA',
    created_at: '17:00 23/11/2023',
    file: 'file.rar',
  },
  {
    id: 6,
    name: 'Đỗ Mỹ Anh',
    role: 'Cửa hàng trưởng',
    content: 'Thông tin chưa chính xác, cần chỉnh sủa lại mã MJHAJSHAJSHJA',
    created_at: '17:00 23/11/2023',
    file: 'file.rar',
  },
];

export const listCapitalByProduct = [
  { id: 1, name: 'Tủ Xman', unit: 'Tủ' },
  { id: 2, name: 'Dây chuyền Platin', unit: 'Cây dây' },
  { id: 3, name: 'Dây chuyền 9999', unit: 'Khay' },
  { id: 4, name: 'Nhẫn vàng', unit: 'Tủ' },
];
